import React, { LinkHTMLAttributes, ReactNode } from "react";
import { InertiaLinkProps, Link, usePage } from "@inertiajs/react";

interface TransLinkProps {
    url: string;
    className?: string;
    onError?: () => void;
    method?: string;
    data?: any;
    preserveState?: boolean;
    children: ReactNode;
    disabled?: boolean;
    title?: string
    onClick?: () => void

}

const TransLink: React.FC<TransLinkProps & Partial<InertiaLinkProps>> = ({
    url,
    className,
    onError = () => { },
    method = "get",
    preserveState = true,
    children,
    disabled = false,
    title,
    onClick = () => { },
    data,
    href='',
    ...rest
}) => {
    const { locale } = usePage().props;
    if (url && url.startsWith("/")) {
        url = url.substring(1);
    }

    let externalLink = false;
    if (url && url.startsWith("http")) {
        externalLink = true;
    }

    if (externalLink) {
        
        return (
            <a href={url} target="_blank" rel="noopener noreferrer">
                {children}
            </a>
        );
    }

    return disabled ? (
        <Link
            {...rest}
            onClick={onClick}
            title={title}
            as="button"
            disabled={disabled}
            href={`/${locale}/${url}`}
            className={className}
            onError={onError}
            method={method}
            preserveState={preserveState}
            data={data}

        >
            {children}
        </Link>
    ) : (
        <Link
            {...rest}
            onClick={onClick}
            title={title}
            href={`/${locale}/${url}`}
            className={className}
            onError={onError}
            method={method}
            preserveState={preserveState}
            data={data}
        >
            {children}
        </Link>
    );
};

export default TransLink;
